export const preCreatingFinStrScenarioValues = (data, financial_structure) => {
  const waterfall_items = financial_structure.scenario_fin_struct_waterfall_items ?
    financial_structure.scenario_fin_struct_waterfall_items :
    financial_structure.waterfall_items;
  const dataValues = Object.values(data);
  let count = 2;

  return waterfall_items.map((item) => {

    const itemKeys = Object.keys(item.data);
    const itemValues = Object.values(item.data);
    const waterfall_item = {
      data: {},
      waterfall_item_id: item.waterfall_item_id
    };

    itemKeys.map((key, i) => {
      if (itemValues[i].type === 'integer' || itemValues[i].type === 'number') {
        waterfall_item.data[key] = +dataValues[count + i];
      } else {
        waterfall_item.data[key] = dataValues[count + i];
      }
    });
    count += itemKeys.length;
    return waterfall_item;
  });
};


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/ScenarioFinStr/helpers.js